<footer class="app-footer">
  <div class="footer-container">
    <div class="footer-brand">
      <span class="footer-logo">KnOot Academy</span>
      <span class="footer-copyright">&copy; {{ currentYear }}</span>
    </div>

    <nav class="footer-nav" [attr.aria-label]="contentLanguage() === 'EN' ? 'Legal links' : 'Rechtliche Links'">
      @for (link of footerLinks; track link.label) {
        <a [href]="link.href" target="_blank" rel="noopener noreferrer" class="footer-link">
          {{ contentLanguage() === 'EN' ? link.labelEn : link.label }}
        </a>
      }
    </nav>
  </div>
</footer>
